<template>
  <div>
    <navigation-list avatar
                     item-edit-route-name="administration-customer"
                     v-bind:items="items" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  import NavigationList from '@/components/common/NavigationList'

  export default {
    components: {
      NavigationList
    },
    computed: {
      ...mapGetters([ 'customers' ]),
      items() {
        return [...this.customers].map(s => ({
          ...s,
          code: this.getCode(s.companyName),
          title: s.companyName,
          subtitle: s.streetAddress == null ? '' : `${s.streetAddress}, ${s.postalCode} ${s.city}`
        }))
      }
    },
    methods: {
      getCode(companyName) {
        if (companyName == null) {
          return null
        }

        return companyName.match(/\b(\w)/g).join('').substr(0, 2)
      }
    },
    name: 'CustomerNavigation'
  }
</script>